import {Directive, input} from '@angular/core';

@Directive({
  selector: '[msTab]',
  host: {
    '[class.active]': 'isActive',
  },
})
export class TabDirective {
  readonly name = input<any>(undefined, {alias: 'msTab'});

  isActive: boolean;
}
